import { COLOR_POR_PROBABILIDAD, COLOR_POR_RIESGO, resolverColorSemantico } from "../lib/colorSemantico";

const NEUTRO = "bg-fondo text-texto-secundario";

const COLORES_ESTADO: Record<string, string> = {
  "Consulta Inicial": NEUTRO,
  "En Trámite": "bg-info/15 text-info",
  "Con Resolución": "bg-exito/15 text-exito",
  "En Ejecución o Cobro": "bg-advertencia/15 text-advertencia",
  Archivado: NEUTRO,
  Desistido: NEUTRO,
  Pendiente: "bg-advertencia/15 text-advertencia",
  Cumplido: "bg-exito/15 text-exito",
  Cancelado: NEUTRO,
  Vencido: "bg-error/15 text-error",
  Activo: "bg-exito/15 text-exito",
  Suspendido: "bg-error/15 text-error",
  Ingreso: "bg-exito/15 text-exito",
  Gasto: "bg-advertencia/15 text-advertencia",
};

const COLORES_PRIORIDAD: Record<string, string> = {
  Alta: "bg-error/15 text-error",
  Media: "bg-advertencia/15 text-advertencia",
  Baja: NEUTRO,
};

export function Insignia({
  texto,
  tipo = "estado",
  claveColor,
  colorSemantico,
}: {
  texto: string;
  tipo?: "estado" | "prioridad" | "riesgo" | "probabilidad";
  /** Clave para buscar el color cuando `texto` no es el valor "bare" (ej. lleva un prefijo como "Riesgo: Alto"). */
  claveColor?: string;
  /** Cuando el color ya viene resuelto desde un catálogo (ej. Estado Procesal, ver colores_catalogo), se usa directo en vez de buscarlo en los mapas fijos de `tipo`. */
  colorSemantico?: string | null;
}) {
  const clave = claveColor ?? texto;
  let clase: string;
  if (colorSemantico !== undefined) {
    clase = resolverColorSemantico(colorSemantico).chip;
  } else if (tipo === "riesgo") {
    clase = COLOR_POR_RIESGO[clave] ? resolverColorSemantico(COLOR_POR_RIESGO[clave]).chip : NEUTRO;
  } else if (tipo === "probabilidad") {
    clase = COLOR_POR_PROBABILIDAD[clave] ? resolverColorSemantico(COLOR_POR_PROBABILIDAD[clave]).chip : NEUTRO;
  } else if (tipo === "prioridad") {
    clase = COLORES_PRIORIDAD[clave] ?? NEUTRO;
  } else {
    clase = COLORES_ESTADO[clave] ?? NEUTRO;
  }
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${clase}`}>{texto}</span>
  );
}
